const actions = {
	GET_SAMPLE_EXAM: 'GET_SAMPLE_EXAM',
	GET_SAMPLE_EXAM_SUCCESS: 'GET_SAMPLE_EXAM_SUCCESS',

	GET_SAMPLE_EXAM_BY_ID: 'GET_SAMPLE_EXAM_BY_ID',
	GET_SAMPLE_EXAM_BY_ID_SUCCESS: 'GET_SAMPLE_EXAM_BY_ID_SUCCESS',

	DELETE_SAMPLE_EXAM: 'DELETE_SAMPLE_EXAM',
	POST_SAMPLE_EXAM: 'POST_SAMPLE_EXAM',
	PUT_SAMPLE_EXAM: 'PUT_SAMPLE_EXAM',

	GET_QUESTION_FOR_CREATE: 'GET_QUESTION_FOR_CREATE',
	GET_QUESTION_FOR_CREATE_SUCCESS: 'GET_QUESTION_FOR_CREATE_SUCCESS',

	GET_ID_QUESTION_FOR_UPDATE: 'GET_ID_QUESTION_FOR_UPDATE',

	GET_SPECIAL_STUDENTS_MOCKTEST: 'GET_SPECIAL_STUDENTS_MOCKTEST',
	GET_SPECIAL_STUDENTS_MOCKTEST_SUCCESS: 'GET_SPECIAL_STUDENTS_MOCKTEST_SUCCESS',

	GET_SPECIAL_STUDENTS_MOCKTEST_BY_ID: 'GET_SPECIAL_STUDENTS_MOCKTEST_BY_ID',
	GET_SPECIAL_STUDENTS_MOCKTEST_BY_ID_SUCCESS: 'GET_SPECIAL_STUDENTS_MOCKTEST_BY_ID_SUCCESS',

	DELETE_SPECIAL_STUDENTS_MOCKTEST: 'DELETE_SPECIAL_STUDENTS_MOCKTEST',
	POST_SPECIAL_STUDENTS_MOCKTEST: 'POST_SPECIAL_STUDENTS_MOCKTEST',
	PUT_SPECIAL_STUDENTS_MOCKTEST: 'PUT_SPECIAL_STUDENTS_MOCKTEST',

	getSampleExam: (model) => ({
		type: actions.GET_SAMPLE_EXAM,
		payload: { model },
	}),

	getSampleExamById: (model) => ({
		type: actions.GET_SAMPLE_EXAM_BY_ID,
		payload: { model },
	}),

	deleteSampleExam: (model, _success) => ({
		type: actions.DELETE_SAMPLE_EXAM,
		payload: { model },
		_success,
	}),

	postSampleExam: (model, _success) => ({
		type: actions.POST_SAMPLE_EXAM,
		payload: { model },
		_success,
	}),

	putSampleExam: (model, _success) => ({
		type: actions.PUT_SAMPLE_EXAM,
		payload: { model },
		_success,
	}),

	getQuestionForCreate: (model) => ({
		type: actions.GET_QUESTION_FOR_CREATE,
		payload: { model },
	}),

	getIdQuestionForUpdate: (payload) => ({
		type: actions.GET_ID_QUESTION_FOR_UPDATE,
		payload,
	}),

	getIdQuestionForUpdate: (payload) => ({
		type: actions.GET_ID_QUESTION_FOR_UPDATE,
		payload,
	}),

	getSpecialStudentsMockTest: (model) => ({
		type: actions.GET_SPECIAL_STUDENTS_MOCKTEST,
		payload: { model },
	}),

	getSpecialStudentsMockTestById: (model) => ({
		type: actions.GET_SPECIAL_STUDENTS_MOCKTEST_BY_ID,
		payload: { model },
	}),

	deleteSpecialStudentsMockTest: (model, _success) => ({
		type: actions.DELETE_SPECIAL_STUDENTS_MOCKTEST,
		payload: { model },
		_success,
	}),

	addSpecialStudentsMockTest: (model, _success) => ({
		type: actions.POST_SPECIAL_STUDENTS_MOCKTEST,
		payload: { model },
		_success,
	}),

	putSpecialStudentsMockTest: (model, _success) => ({
		type: actions.PUT_SPECIAL_STUDENTS_MOCKTEST,
		payload: { model },
		_success,
	}),
};

export default actions;
